export const TOGGLE_SORT_MENU = 'TOGGLE_SORT_MENU';

export const toggleSortMenu = (isOpen) => ({
    type: TOGGLE_SORT_MENU,
    payload: isOpen
});